import React from 'react';
import GroupsPage from './GroupsPage';
import Backend from '../../../Layouts/Backend';
import Loading from '../../../Helpers/Loading';
import { connect } from 'react-redux';
import { configureActions } from '../../../../actions/configure.action';

class Groups extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      groups: [],
      loading: false,
      isFetching: false,
      errors: '',
      openModal: false,
      selectedRow: null,
    };
    this.columns = [
      {
        dataField: 'department',
        text: 'Department',
        sort: true,
      },
      {
        dataField: 'name',
        text: 'Group Name',
        sort: true,
      },
      {
        dataField: 'shortName',
        text: 'Short Name',
        sort: true,
      },
      {
        dataField: 'userCount',
        text: 'Users',
        sort: true,
        headerStyle: { width: 70, textAlign: 'center' },
        align: 'center',
      },
      {
        dataField: 'sensorCount',
        text: 'Sensors',
        sort: true,
        headerStyle: { width: 80, textAlign: 'center' },
        align: 'center',
      },
      {
        dataField: 'escalationTimeoutMin',
        text: 'Escalation',
        sort: true,
        headerStyle: { width: 100, textAlign: 'center' },
        align: 'center',
      },
      {
        dataField: 'resendTimeoutMin',
        text: 'Resend',
        sort: true,
        headerStyle: { width: 75, textAlign: 'center' },
        align: 'center',
      },
      {
        dataField: 'mapPageId',
        text: 'Map Page ID',
        sort: true,
      },
    ];
    this.defaultSorted = [
      {
        dataField: 'name',
        order: 'asc',
      },
    ];
    this.ctxMenuOptions = [
      [
        {
          name: 'Assign users',
          action: (row, rowIndex) => {
            this.props.history.push(`/configure/groups/assign-users/${row.id}`);
          },
        },
        {
          name: 'Assign alerts',
          action: (row, rowIndex) => {
            this.props.history.push(
              `/configure/groups/assign-alerts/${row.id}`,
            );
          },
        },
        {
          name: 'Maintain database',
          action: (row, rowIndex) => {
            this.props.history.push(`/configure/groups/maintain-db/${row.id}`);
          },
        },
        {
          name: 'Edit group',
          action: (row, rowIndex) => {
            this.props.history.push(`/configure/groups/edit-group/${row.id}`);
          },
        },
        {
          name: 'Delete group',
          // className: (row, rowIndex) => {
          //   if (row) {
          //     return row.numGroups ? 'item-disable' : '';
          //   }
          // },
          action: (row, rowIndex) => {
            this.setState({ openModal: true, selectedRow: row });
          },
        },
      ],
    ];
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let state = {};
    if (nextProps.configure.groups !== prevState.groups) {
      state.groups = nextProps.configure.groups;
    }
    if (nextProps.configure.loading !== prevState.loading) {
      state.loading = nextProps.configure.loading;
    }
    if (nextProps.configure.isFetching !== prevState.isFetching) {
      state.isFetching = nextProps.configure.isFetching;
    }
    return Object.keys(state).length ? state : null;
  }

  async componentDidMount() {
    await this.props.getGroups();
  }

  onCancel = () => {
    this.setState({ openModal: false, selectedRow: null });
  };

  onDeleteGroup = () => {
    const { selectedRow } = this.state;
    this.setState(
      { openModal: false, isFetching: true },
      async () =>
        await this.props.deleteGroup(selectedRow.id).then(async (isDeleted) => {
          if (isDeleted) {
            await this.props.getGroups();
          }
        }),
    );
  };

  render() {
    const { loading, groups, openModal, isFetching } = this.state;
    if (loading) {
      return (
        <Backend>
          <Loading />
        </Backend>
      );
    }
    return (
      <GroupsPage
        groups={groups}
        columns={this.columns}
        defaultSorted={this.defaultSorted}
        ctxMenuOptions={this.ctxMenuOptions}
        isFetching={isFetching}
        errors={this.props.configure.errors}
        openModal={openModal}
        onCancel={this.onCancel}
        onDeleteGroup={this.onDeleteGroup}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    configure: state.configure,
  };
}

export default connect(mapStateToProps, configureActions)(Groups);
